import { useGqlQuery } from '@api/gql/gqlServices'
import { GetRewardsRedeemedDocument, GetRewardsRedeemedQuery, RewardRedeemed } from '@generated/generates'

const useRedeemables = () => {
  const {
    data: rewardsRedeemData,
    isPending: isRewardsRedeemablesLoading,
    status: rewardsRedeemablesStatus
  } = useGqlQuery<GetRewardsRedeemedQuery>(GetRewardsRedeemedDocument, {
    input: { redeemed: false }
  })

  const redeemablesArray =
    rewardsRedeemablesStatus === 'success' ? (rewardsRedeemData?.rewardsRedeemed as RewardRedeemed[]) : null

  return {
    rewardsRedeemables: redeemablesArray,
    isRewardsRedeemablesLoading,
    rewardsRedeemablesStatus
  }
}

export default useRedeemables
